<template>
    <div class="main">
        <div class="wp4">
            <div class="page-tit dffs">
                <router-link class="back-btn" to="/userCenter/1v1/newRoadshowVideo"></router-link>
                {{ filmData.name }} <!-- 动态显示影片名称 -->
            </div>

            <div class="film-det">
                <div class="film-box">
                    <div class="pic">
                        <img :src="filmData.img" alt="">
                    </div>
                    <div class="text">
                        <div class="box">
                            <h4>一句话梗概</h4>
                            <p v-html="filmData.content.synopsis" class="text-justify"></p>
                        </div>
                        <div class="box" v-if="filmData.content.outline">
                            <h4>故事大纲</h4>
                            <p v-html="filmData.content.outline" class="text-justify"></p>
                        </div>
                    </div>
                </div>

                <div class="film-info">
                    <div class="film-mod-tit">影片信息</div>
                    <div class="film-info-list">
                        <dl v-for="(item, index) in filmData.content.pList" :key="index">
                            <dd>
                                <p>{{ item.split('：')[0] }}：</p>
                                <span>{{ item.split('：')[1] }}</span>
                            </dd>
                        </dl>
                    </div>
                </div>



                <div class="director-info-wrap">
                    <div class="director-info bbn" v-if="filmData.content.directorIntro">
                        <div class="title">导演简介</div>
                        <div class="box">
                            <div class="text">
                                <h3><span>{{ filmData.content.directorName }}</span></h3>
                                <p v-html="filmData.content.directorIntro"></p>
                            </div>
                        </div>
                    </div>

                    <div class="director-info bbn" v-if="filmData.content.heroIntro">
                        <div class="title">男主角简介</div>
                        <div class="box">
                            <div class="text">
                                <h3><span>{{ filmData.content.heroName }}</span></h3>
                                <p v-html="filmData.content.heroIntro"></p>
                            </div>
                        </div>
                    </div>

                    <div class="director-info bbn" v-if="filmData.content.heroineIntro">
                        <div class="title">女主角简介</div>
                        <div class="box">
                            <div class="text">
                                <h3><span>{{ filmData.content.heroineName }}</span></h3>
                                <p v-html="filmData.content.heroineIntro"></p>
                            </div>
                        </div>
                    </div>

                    <div class="director-info bbn" v-if="filmData.content.writersIntro">
                        <div class="title">编剧简介</div>
                        <div class="box">
                            <div class="text">
                                <h3><span>{{ filmData.content.writersName }}</span></h3>
                                <p v-html="filmData.content.writersIntro"></p>
                            </div>
                        </div>
                    </div>

                    <div class="director-info bbn" v-if="filmData.content.producerIntro">
                        <div class="title">制片人简介</div>
                        <div class="box">
                            <div class="text">
                                <h3><span>{{ filmData.content.producerName }}</span></h3>
                                <p v-html="filmData.content.producerIntro"></p>
                            </div>
                        </div>
                    </div>

                    <div class="director-info bbn" v-if="filmData.content.produceCompanyIntro">
                        <div class="title">制片公司简介</div>
                        <div class="box">
                            <div class="text">
                                <h3><span>{{ filmData.content.produceCompanyName }}</span></h3>
                                <p v-html="filmData.content.produceCompanyIntro"></p>
                            </div>
                        </div>
                    </div>

                    <div class="director-info bbn" v-if="filmData.content.superviseIntro">
                        <div class="title">监制简介</div>
                        <div class="box">
                            <div class="text">
                                <h3><span>{{ filmData.content.superviseName }}</span></h3>
                                <p v-html="filmData.content.superviseIntro"></p>
                            </div>
                        </div>
                    </div>

                    <div class="director-info bbn" v-if="filmData.content.outline">
                        <div class="title">故事大纲</div>
                        <div class="box">
                            <div class="text">
                                <h3><span>{{ filmData.content.outlineTitle }}</span></h3>
                                <p v-html="filmData.content.outline"></p>
                            </div>
                        </div>
                    </div>

                    <div class="director-info bbn" v-if="filmData.content.creation">
                        <div class="title">创作阐述</div>
                        <div class="box">
                            <div class="text">
                                <h3><span>{{ filmData.content.creationTitle }}</span></h3>
                                <p v-html="filmData.content.creation"></p>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="film-video" v-if="filmData.videoZj">
                    <div class="title">终极路演视频</div>
                    <div class="video">
                        <video name="videoArea" :src="filmData.videoZj" controls controlslist="nodownload" />
                    </div>
                </div>
                <div class="film-video" v-if="filmData.video">
                    <div class="title">中期路演视频：</div>
                    <div class="video">
                        <video name="videoArea" :src="filmData.videoZj" controls controlslist="nodownload" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import filmJson from '@/static/newRoadShowFilm.json';
import { sessionData } from "@/static/js/local.js";

export default {
    data() {
        return {
            filmData: {}
        }
    },

    created() {
        if (!this.$cookies.isKey("token")) {
            this.$router.push("/login");
            return
        }
        let detailForm = sessionData("get", "UserInfo");
        let isInvestor = detailForm.details.some(item => item.guestType == "10" && item.verifyFlag == 1);

        if (!isInvestor) {
            this.$msgbox({
                title: "提示",
                message: "您还不是一对一洽谈创投嘉宾，请先报名成为创投嘉宾再进行观看",
                showClose: false,
                confirmButtonClass: "btn-color",
                closeOnClickModal: false,
                closeOnPressEscape: false,
                callback: (action, instance) => {
                    if (action == "confirm") {
                        this.$router.push("/1v1/vc");
                    }
                }
            });
            return;
        }

        let id = this.$route.query.id;
        if (!id) {
            this.$message.warning('找不到该部影片信息，请重试');
            this.goBack();
            return
        }
        this.filmData = filmJson[this.$route.query.type + 'Film'].find(item => item.id === id);
    },
    mounted() {
        // 禁止视频右击
        $('[name="videoArea"]').bind('contextmenu', function () { return false; });
    },
    methods: {
        goBack() {
            this.$router.push({
                path: '/1v1/road_show',
                query: {
                    type: this.$route.query.type
                }
            });
        }
    }
}
</script>
<style scoped>
.film-info-list {
    display: flex;
    /* 允许内容换行 */
    flex-wrap: wrap;
    justify-content: space-between;
    padding-bottom: 20px;

    /* 在每行中均匀分配空间 */
    dd {
        margin-bottom: 20px;
    }

}

.film-info-list dl {
    flex: 1 1 48%;
    /* 每个dl占用48%宽度，允许自动调整 */
    /* 设置底部间距，避免过于紧凑 */
    box-sizing: border-box;
    /* 保证padding和border不会影响宽度计算 */
}

.film-info-list dl:nth-child(2n+1) {
    margin-right: 4%;
    /* 设置间隔，使每行两个元素之间有间距 */
}

.film-info-list dl+dl {
    border: none;
}

.film-info-list dl {
    padding: 0;
}

.director-info {
    margin-bottom: 56px;

    .text h3 {
        margin-bottom: 0;
    }

    .box .text {
        padding-top: 0;
    }
}
</style>
